"use client";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Home } from "lucide-react";

export default function NotFound() {
  const year = 2025;

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)] font-sans flex flex-col">
      <Header />
      
      {/* Background elements matching main site */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-0 left-0 w-1/3 h-[500px] rounded-full bg-[var(--brand-dark)]/15 blur-[100px] -z-10"
          style={{
            transform: "translateZ(0)",
            willChange: "transform",
            backfaceVisibility: "hidden",
          }}
        ></div>
        <div
          className="absolute top-[30%] right-0 w-1/3 h-[400px] rounded-full bg-[var(--accent-color)]/8 blur-[100px] -z-10"
          style={{
            transform: "translateZ(0)",
            willChange: "transform",
            backfaceVisibility: "hidden",
          }}
        ></div>
        <div
          className="absolute bottom-0 left-[40%] w-1/3 h-[300px] rounded-full bg-[var(--brand-color)]/8 blur-[100px] -z-10"
          style={{
            transform: "translateZ(0)",
            willChange: "transform",
            backfaceVisibility: "hidden",
          }}
        ></div>
      </div>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-6 py-12 pt-32">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Error label */}
            <motion.p
              className="eyebrow font-mono uppercase tracking-[0.18em] text-[var(--brand-color)] mb-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Error 404
            </motion.p>

            {/* 404 Number */}
            <motion.h1
              className="text-8xl md:text-9xl font-display font-medium tracking-tight mb-6 text-[var(--text-primary)]"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              404
            </motion.h1>

            {/* Error Message */}
            <motion.h2
              className="text-2xl md:text-3xl font-display font-medium tracking-tight mb-4 text-[var(--text-primary)]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Page Not Found
            </motion.h2>

            <motion.p
              className="text-lg text-[var(--text-secondary)] mb-8 max-w-md mx-auto"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              The page you're looking for doesn't exist or has been moved. Let me
              get you back on track.
            </motion.p>

            {/* Action button */}
            <motion.div
              className="flex justify-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              <motion.a
                href="/"
                className="flex items-center gap-2 px-6 py-3 bg-[var(--bg-secondary)] hover:bg-[var(--bg-tertiary)] text-[var(--text-primary)] hover:text-[var(--brand-color)] transition-all duration-300 border border-[var(--border-color)] hover:border-[var(--brand-color)]/50 rounded-sm group"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Home size={20} className="group-hover:text-[var(--brand-color)] transition-colors" />
                Return Home
              </motion.a>
            </motion.div>
          </motion.div>
        </div>
      </main>

      <Footer year={year} />
    </div>
  );
}